

export function redirectToLogin(reason: string) {
    console.log('Redirecting to login reason [' + reason + ']');
    window.location.assign(getLoginPath() +  '?ref=' + encodeURI(window.location.href));
}


export function getLoginPath() {
    const isDevMode = location.pathname.endsWith('/dev');
    return '/auth/login' + (isDevMode ? '/dev' : '');
}